<template>
  <!-- Fixed: the layouts are h-screen. -->
  <div
    v-if="tag"
    class="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex justify-center"
  >
    <AuxoBanner
      data-testid="preview-banner"
      class="pointer-events-auto"
      variant="warning"
      layout="short"
    >
      Preview {{ tag }} -
      <!-- Plain link: /_release/exit is handled at the edge. -->
      <a
        data-testid="preview-banner-exit"
        class="font-bold underline"
        :href="RELEASE_EXIT_PATH"
        >exit</a
      >
    </AuxoBanner>
  </div>
</template>

<script setup>
import AuxoBanner from '@/components/auxo/AuxoBanner.vue';
import { RELEASE_EXIT_PATH, releaseTag } from '@/utils/slot';

const tag = releaseTag();
</script>
